export default {
  "mainVegetable": "vihannekset",
  "mainVegetable/01": "vihannekset/munakoiso",
  "mainVegetable/02": "vihannekset/parsa",
  "mainVegetable/03": "vihannekset/avokado",
  "mainVegetable/04": "vihannekset/punajuuri",
  "mainVegetable/05": "vihannekset/parsakaali",
  "mainVegetable/06": "vihannekset/porkkana",
  "mainVegetable/07": "vihannekset/selleri",
  "mainVegetable/08": "vihannekset/herkkusienet",
  "mainVegetable/09": "vihannekset/kaali",
  "mainVegetable/10": "vihannekset/ruusukaali",
  "mainVegetable/11": "vihannekset/kiinankaali",
  "mainVegetable/12": "vihannekset/kukkakaali",
  "mainVegetable/13": "vihannekset/coleslaw",
  "mainVegetable/14": "vihannekset/kurkku",
  "mainVegetable/15": "vihannekset/kesakurpitsa",
  "mainVegetable/16": "vihannekset/endiivi",
  "mainVegetable/17": "vihannekset/pinaatti",
  "mainVegetable/18": "vihannekset/harkapavut",
  "mainVegetable/19": "vihannekset",
  "mainVegetable/20": "vihannekset",
  "mainVegetable/21": "vihannekset/kuivatut-pavut",
  "mainVegetable/22": "vihannekset/vihreat-pavut",
  "mainVegetable/23": "vihannekset/linssit",
  "mainVegetable/24": "vihannekset/vihannessekoitus",
  "mainVegetable/25": "vihannekset/maissi",
  "mainVegetable/26": "vihannekset/salaattisekoitus",
  "mainVegetable/27": "vihannekset/rypsi",
  "mainVegetable/28": "vihannekset/sipuli",
  "mainVegetable/29": "vihannekset/edamamepavut",
  "mainVegetable/30": "vihannekset/paprika",
  "mainVegetable/31": "vihannekset/peruna",
  "mainVegetable/32": "vihannekset/pavunidut",
  "mainVegetable/33": "vihannekset/retiisit",
  "mainVegetable/34": "vihannekset/lehtisalaatti",
  "mainVegetable/35": "vihannekset/friseesalaatti",
  "mainVegetable/36": "vihannekset/jaavuorisalaatti",
  "mainVegetable/37": "vihannekset",
  "mainVegetable/38": "vihannekset/riisisalaatti",
  "mainVegetable/39": "vihannekset/romaine-salaatti",
  "mainVegetable/40": "vihannekset",
  "mainVegetable/41": "vihannekset/salaatti",
  "mainVegetable/42": "vihannekset/vuonankaali",
  "mainVegetable/43": "vihannekset/rucola",
  "mainVegetable/44": "vihannekset",
  "mainVegetable/45": "vihannekset",
  "mainVegetable/46": "vihannekset/tomaatti",
  "mainVegetable/47": "vihannekset/voipavut",
  "mainVegetable/48": "vihannekset/kikherneet",
  "mainVegetable/49": "vihannekset/purjo",
  "mainVegetable/50": "vihannekset/kurpitsa",
  "mainVegetable/51": "vihannekset/punaiset-kidneypavut",
  "mainVegetable/52": "vihannekset/omena",
  "mainVegetable/53": "vihannekset/kastanja",
  "mainVegetable/54": "vihannekset/luumu",
  "mainVegetable/55": "vihannekset",
  "mainVegetable/56": "vihannekset/mustat-oliivit",
  "mainVegetable/57": "vihannekset/artisokka",
  "mainVegetable/58": "vihannekset/punainen-paprika",
  "mainVegetable/59": "vihannekset",
  "mainVegetable/60": "vihannekset",
  "mainVegetable/61": "vihannekset/ratatouille",
  "mainVegetable/62": "vihannekset/couscous",
  "mainVegetable/63": "vihannekset",
  "mainVegetable/64": "vihannekset",
  "mainVegetable/65": "vihannekset",
  "mainVegetable/66": "vihannekset",
  "mainVegetable/67": "vihannekset/punaiset-linssit",
  "mainVegetable/68": "vihannekset/kvinoa",
  "mainVegetable/69": "vihannekset/speltti",
  "mainVegetable/70": "vihannekset/bulgur",
  "mainVegetable/71": "vihannekset/punakaali",
  "mainVegetable/72": "vihannekset/lehtikaali",
  "mainVegetable/73": "vihannekset/kirveli",
  "mainVegetable/74": "vihannekset",
  "mainVegetable/75": "vihannekset/palkokasvit",
  "mainVegetable/76": "vihannekset/bataatti",
  "mainVegetable/77": "vihannekset/kurpitsa",
  "mainVegetable/78": "vihannekset",
  "mainVegetable/79": "vihannekset/pavut",
  "mainVegetable/80": "vihannekset/herneet-ja-porkkanat",
  "mainVegetable/81": "vihannekset/herneet",
  "mainVegetable/82": "vihannekset/edamamepavut",
  "mainVegetable/83": "vihannekset",
  "mainVegetable/84": "vihannekset",
  "mainVegetable/85": "vihannekset",
  "mainVegetable/86": "vihannekset",
  "mainVegetable/87": "vihannekset",
  "mainVegetable/88": "vihannekset",
  "mainVegetable/89": "vihannekset",
  "mainVegetable/90": "vihannekset/palsternakka",
  "mainVegetable/91": "vihannekset",
  "mainVegetable/92": "vihannekset/papusekoitus",
  "mainVegetable/93": "vihannekset/mustapavut",
  "mainVegetable/94": "vihannekset/suippokaali",
  "mainVegetable/95": "vihannekset/valkopavut",
  "mainVegetable/96": "vihannekset",
  "mainVegetable/97": "vihannekset",
  "mainVegetable/98": "vihannekset",
  "season": "vuodenaika",
  "season/1": "vuodenaika/kesa",
  "season/2": "vuodenaika/syksy",
  "season/3": "vuodenaika/talvi",
  "season/4": "vuodenaika/kevat",
  "season/5": "vuodenaika",
  "technologie": "teknologia",
  "technologie/AC01": "teknologia/sailykkeet",
  "technologie/AD01": "teknologia",
  "technologie/AG01": "teknologia",
  "technologie/AT01": "teknologia",
  "recipeDish": "oikein",
  "recipeDish/ACC": "oikein/lisukkeet",
  "recipeDish/APE": "oikein",
  "recipeDish/DES": "oikein/jalkiruoka",
  "recipeDish/ENT": "oikein/alkuruoka",
  "recipeDish/PLAT": "oikein/paaruoka",
  "recipeDish/SAL": "oikein/salaatti",
  "recipeDish/SNA": "oikein/snack",
  "recipeDish/PDE": "oikein/aamiainen",
  "recipeDish/DEJ": "oikein/lounas",
  "recipeDish/TRA": "oikein/perinteinen",
  "recipeDish/GOU": "oikein/gourmet",
  "recipeDish/ETH": "oikein/etninen",
  "recipeDish/FCH": "oikein/lapsiystavallinen",
  "recipeDish/SOU": "oikein/keitto",
  "pred-recipeTimingCook-facet": "valmistusaika",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "valmistusaika/0-15-minuuttia",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "valmistusaika/15---30-minuuttia",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "valmistusaika/30-45-minuuttia",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "valmistusaika/45-minuuttia",
  "pred-recipeTimingPreparation-facet": "esivalmisteluaika",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "esivalmisteluaika/0-15-minuuttia",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "esivalmisteluaika/15---30-minuuttia",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "esivalmisteluaika/30-45-minuuttia",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "esivalmisteluaika/45-minuuttia",
  "pred-recipeCost-Facet": "budjetti",
  "pred-recipeCost-Facet/petit": "budjetti/pieni",
  "pred-recipeCost-Facet/moyen": "budjetti/keskikokoinen",
  "pred-recipeCost-Facet/grand": "budjetti/suuri",
  "recipeDifficulty": "vaikeusaste",
  "recipeDifficulty/1": "vaikeusaste/helppo",
  "recipeDifficulty/2": "vaikeusaste/keskitaso",
  "recipeDifficulty/3": "vaikeusaste/vaikea",
  "recipeDishNumber": "annosten-maara",
  "recipeDishNumber/1": "annosten-maara/1",
  "recipeDishNumber/2": "annosten-maara/2",
  "recipeDishNumber/3": "annosten-maara/3",
  "recipeDishNumber/4": "annosten-maara/4",
  "recipeDishNumber/5": "annosten-maara/5",
  "recipeDishNumber/6": "annosten-maara/6",
  "recipeDishNumber/7": "annosten-maara/7",
  "recipeDishNumber/8": "annosten-maara/8",
  "productTheme": "tuoteteemat",
  "productTheme/ACC": "tuoteteemat/lisukkeet",
  "productTheme/BEA": "tuoteteemat/palkokasvit",
  "productTheme/BIS": "tuoteteemat/pavut-kastikkeessa",
  "productTheme/BIO": "tuoteteemat/luomu",
  "productTheme/CAN": "tuoteteemat/sailykkeet",
  "productTheme/CER": "tuoteteemat",
  "productTheme/CLS": "tuoteteemat/klassikot",
  "productTheme/DLE": "tuoteteemat/kasvikset",
  "productTheme/EDR": "tuoteteemat/minipakkaukset",
  "productTheme/ENT": "tuoteteemat/alkuruoka",
  "productTheme/FRZ": "tuoteteemat/pakasteet",
  "productTheme/FSD": "tuoteteemat/salaattiainekset",
  "productTheme/FSH": "tuoteteemat",
  "productTheme/ING": "tuoteteemat/reseptieni-ainekset",
  "productTheme/JAR": "tuoteteemat",
  "productTheme/LBW": "tuoteteemat/lunch-bowl",
  "productTheme/LDF": "tuoteteemat/kypsennetyt-vihannekset",
  "productTheme/LEG": "tuoteteemat/palkokasvit",
  "productTheme/LGO": "tuoteteemat",
  "productTheme/LGR": "tuoteteemat",
  "productTheme/LGS": "tuoteteemat",
  "productTheme/MAI": "tuoteteemat/maissi",
  "productTheme/MUS": "tuoteteemat/herkkusienet",
  "productTheme/NEW": "tuoteteemat/uutuudet",
  "productTheme/PDH": "tuoteteemat",
  "productTheme/PDL": "tuoteteemat",
  "productTheme/PHR": "tuoteteemat",
  "productTheme/PLP": "tuoteteemat/paaruoka",
  "productTheme/RAL": "tuoteteemat",
  "productTheme/RDM": "tuoteteemat",
  "productTheme/SAL": "tuoteteemat",
  "productTheme/SDB": "tuoteteemat/salaattikulhot",
  "productTheme/SNK": "tuoteteemat",
  "productTheme/SUP": "tuoteteemat/keitto",
  "productTheme/TEX": "tuoteteemat/tex-mex",
  "productTheme/VGP": "tuoteteemat",
  "recipeTheme": "reseptin-teema",
  "recipeTheme/01": "reseptin-teema/juhlat",
  "recipeTheme/02": "reseptin-teema",
  "recipeTheme/03": "reseptin-teema/salaatit-ja-snacksit",
  "recipeTheme/04": "reseptin-teema/keitot",
  "recipeTheme/05": "reseptin-teema",
  "recipeTheme/06": "reseptin-teema",
  "recipeTheme/07": "reseptin-teema/jalkiruoat",
  "recipeTheme/08": "reseptin-teema/kasvisruoat",
  "recipeTheme/09": "reseptin-teema/lisukkeet",
  "recipeTheme/10": "reseptin-teema",
  "recipeTheme/11": "reseptin-teema",
  "recipeTheme/12": "reseptin-teema",
  "recipeTheme/13": "reseptin-teema/snacks-ja-sormiruoka",
  "recipeTheme/14": "reseptin-teema/paaruoat",
  "recipeTheme/15": "reseptin-teema/jalkiruoat-ja-leivonnaiset",
  "recipeTheme/16": "reseptin-teema/alkuruoat-ja-keitot",
  "recipeTheme/17": "reseptin-teema/salaatit",
  "recipeTheme/18": "reseptin-teema/kulhoruoat",
  "recipeTheme/19": "reseptin-teema/keitot",
  "recipeTheme/20": "reseptin-teema",
  "recipeTheme/21": "reseptin-teema/kastikkeet",
  "recipeTheme/22": "reseptin-teema",
  "recipeTheme/23": "reseptin-teema/paaruoat",
  "recipeTheme/24": "reseptin-teema/uuniruoat",
  "recipeTheme/25": "reseptin-teema",
  "recipeTheme/26": "reseptin-teema",
  "recipeTheme/27": "reseptin-teema",
  "recipeTheme/28": "reseptin-teema",
  "recipeTheme/33": "reseptin-teema",
  "recipeTheme/34": "reseptin-teema",
  "recipeTheme/35": "reseptin-teema",
  "recipeTheme/36": "reseptin-teema",
  "recipeTheme/37": "reseptin-teema",
  "recipeTheme/38": "reseptin-teema",
  "recipeTheme/39": "reseptin-teema",
  "recipeTheme/40": "reseptin-teema",
  "recipeTheme/41": "reseptin-teema",
  "recipeTheme/42": "reseptin-teema",
  "recipeTheme/43": "reseptin-teema",
  "recipeTheme/44": "reseptin-teema",
  "recipeTheme/45": "reseptin-teema",
  "recipeTheme/46": "reseptin-teema",
  "pred-particularite": "kategoriat",
  "pred-particularite/Sans%20conservateur": "kategoriat/ilman-sailontaaineita",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "kategoriat",
  "pred-particularite/Sans%20colorant": "kategoriat/ilman-variaineita",
  "pred-particularite/Sans%20sucre%20ajout%E9": "kategoriat/ilman-lisattya-sokeria",
  "pred-particularite/Sans%20sel%20ajout%E9": "kategoriat/ilman-lisattya-suolaa",
  "pred-particularite/Sans%20additif": "kategoriat/ilman-lisaaineita",
  "pred-particularite/": "kategoriat/luontainen-suolapitoisuus",
  "pred-particularite/Sans%20lactose": "kategoriat/laktoositon",
  "pred-particularite/Sans%20gluten": "kategoriat/gluteeniton",
  "pred-particularite/V%E9g%E9tarien": "kategoriat/kasviperainen",
  "pred-particularite/V%E9g%E9talien": "kategoriat/vegaaninen",
  "pred-particularite/Sans%20sulfite": "kategoriat",
  "pred-particularite/A%20la%20vapeur": "kategoriat",
  "pred-particularite/Sans%20condiment": "kategoriat",
  "cultureType": "nayta-vain",
  "cultureType/Bio": "nayta-vain/luomu",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "nayta-vain/ei-torjunta-ainejaamia",
  "cultureType/Sans%20OGM": "nayta-vain/gmo-vapaa",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "kategoriat/vegaaninen",
  "pred-particularite/recipeVeggie": "kategoriat/vegetaarinen",
  "pred-particularite/recipeGlutenfree": "kategoriat/gluteeniton",
  "pred-particularite/recipeLactosefree": "kategoriat/laktoositon"
};
